import CircleCheckList, { ListItem } from "components/ui/CircleCheckList"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

function ProductHighlightsSection() {
  return (
    <Container section>
      <Heading
        label="Product Highlights"
        title="Features designed to support all data users"
        subtitle={
          <>
            Run fast queries and customize your analytics experiences to get
            answers to your questions any way you want.
          </>
        }
        decoration="border"
      />
      <CircleCheckList className="mt-10 md:mt-16">
        <ListItem>
          <strong>Caching for charts & dashboards</strong> helps reduce the load
          on your data stack
        </ListItem>
        <ListItem>
          The <strong>semantic layer</strong> enables last-mile SQL data
          transformations
        </ListItem>
        <ListItem>
          <strong>Jinja templating and dashboard filters</strong> help you build
          more dynamic dashboards
        </ListItem>
        <ListItem>
          <strong>Dashboard CSS templates</strong> customize the look and feel
          of your dashboards to match your product and brand
        </ListItem>
        <ListItem>
          <strong>Row-level security</strong> prevents unauthorized access to
          sensitive data
        </ListItem>
        <ListItem>
          <strong>Alerts and reports in Slack or email</strong> notify you when
          events in your dashboards are triggered
        </ListItem>
      </CircleCheckList>
    </Container>
  )
}

export default ProductHighlightsSection
